"use client";

import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className={`
          max-w-3xl mx-auto text-center
          transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}
        `}>
        <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground mb-4">
          Ready for Reliable HVAC Service?
        </h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
          Experience impeccable craftsmanship and customer satisfaction. Contact K&M Mechanical Services today for all your heating, ventilation, and air conditioning needs.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <Link to="tel:4129800953" className="inline-flex items-center gap-3 text-2xl sm:text-3xl font-display font-bold text-primary hover:text-primary-hover transition-colors duration-[var(--duration-medium)]"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-8" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/ContactCallToAction.tsx|sig:rijs1y" data-ast-start="1405" data-ast-end="1999"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" data-ast-id="f:/src/pages/Home/sections/ContactCallToAction.tsx|sig:8g5dr1" data-ast-start="1762" data-ast-end="1993"></path></svg>(412) 980-0953</Link>
          
          <Button asChild size="lg" className="transition-all duration-[120ms] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0">
            <Link to="/ContactPage">Contact Us</Link>
          </Button>
        </div>
      </div>
    </section>;
}